import { useMemo } from "react";
import { STATISTIC_FIELDS } from "~pages/LeaderCriteria/constants/statisticFields.ts";
import { useGetStatisticFieldLabel } from "~pages/LeaderCriteria/hooks/useGetStatisticFieldLabel.ts";

export const useGetStatisticFieldOptions = () => {
  const getStatisticFieldLabel = useGetStatisticFieldLabel();

  return useMemo(
    () =>
      STATISTIC_FIELDS.map((statisticField) => ({
        value: statisticField,
        label: getStatisticFieldLabel(statisticField),
      })).sort((a, b) => a.label.localeCompare(b.label)),
    [getStatisticFieldLabel],
  );
};
